import React from 'react';

import { FlashCardQuizBlockData } from 'api/cms';
import { Box } from 'components/Box';

import { FlashCardQuizBlockCard } from './FlashCardQuizBlockCard';

type Props = {
  blockIndex: number;
  data: FlashCardQuizBlockData;
};

export function FlashCardQuizBlock({ blockIndex, data: { cards } }: Props) {
  return (
    <Box>
      {cards.map((card, index) => (
        <FlashCardQuizBlockCard
          blockIndex={blockIndex} // eslint-disable-next-line react/no-array-index-key
          key={index}
          card={card}
          index={index}
        />
      ))}
    </Box>
  );
}
